export default "__VITE_ASSET__TcDTm9fE__"